// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".collar-leash-select-row[data-v-ee9238ec]{max-width:1024px}", ""]);
// Exports
module.exports = exports;
